// extracted by mini-css-extract-plugin
export default {"PriceWidget":"PriceWidget_PriceWidget__bM-t1","StepBox":"PriceWidget_StepBox__zcOrx","Accent":"PriceWidget_Accent__Pjevu"};